import styled from 'styled-components';

import { MarketingTileGroup } from 'components/features/components/marketing-tile-group';
import SanityBlockRenderer from 'components/sanity-block-renderer';

export const RewardsTitle = styled.h1`
  color: ${Styles.color.primary};
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.25rem;
  text-align: center;

  ${Styles.desktop`
    font-size: 2.5rem;
  `}
`;

export const DisclaimerMessage = styled(SanityBlockRenderer)`
  color: ${Styles.color.white};
  font-size: 0.75rem;
  margin: 0.75rem 0 0.9375rem 0;
  text-align: center;

  ${Styles.desktop`
  font-size: 0.93rem;
  margin: 1.5rem 0 3.125rem 0;
`}
`;

export const StyledMarketingTileGroup = styled(MarketingTileGroup)`
  & > :not(:last-child) {
    margin-bottom: 2rem;
  }
`;
